


(function () {
    'use strict';

    angular.module('itxApp.cmsPage')
        .service('CmsConstant', CmsConstant);

    CmsConstant.$inject = [];

    function CmsConstant(){
        return {
            iPage: {
                ItxHomeBgPage: 'home-web-highlights',
                ItxHomeMenPage: 'home-web-men',
                ItxHomeWomenPage: 'home-web-test',
                ItxHomePage: 'home-web-women'
            },
            header: 'header-web',
            headerCategory: 'header-web-category',
            footer: 'footer-web',
            notification: {
                default: 'mspot-web-notification-shopcart',
                shopcart: 'mspot-web-notification-shopcart',
                purchase: 'mspot-web-notification-purchase'                
            },
            content: {
                shopcart: 'mspot-web-shopping-basket',
                productinfo: 'mspot-web-product-info'
            }
        };
    }

})();
